import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { openDetailView, type Action } from '../../state/actions/detail-view';
import CardIsFiltered from './view';

export default connect(null, (dispatch: Dispatch<Action>) => ({
	onPrimaryActionClick: (cardId: string) => {
		// @ts-expect-error - Argument of type 'string' is not assignable to parameter of type 'number'.
		dispatch(openDetailView(cardId));
	},
}))(CardIsFiltered);
